// import React from 'react';
// import { 
//   TrendingDown, ShieldAlert, Landmark, Scale, 
//   ChevronLeft, CheckCircle2, ShieldCheck, FileSpreadsheet, 
//   HelpCircle, Receipt 
// } from 'lucide-react'; // run: npm i lucide-react
// import { ServicePageHeader } from '../ServicePageHeader';

// export default function BankruptcyProceedings() {
  
//   // Core bankruptcy and financial restructuring offerings
//   const bankruptcyServices = [
//     {
//       title: "إجراء التسوية الوقائية",
//       desc: "تمكين المدين المتعثر من التوصل إلى اتفاق مع دائنيه لإعادة جدولة الديون واستمرار إدارة النشاط دون تدخل أمين الإفلاس، مع الاستفادة من ميزة تعليق المطالبات.",
//       icon: <ShieldCheck className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "إعادة التنظيم المالي",
//       desc: "إعداد ومتابعة مقترحات الهيكلة المالية والإدارية للشركات تحت إشراف أمين إفلاس مرخص، لضمان استمرارية التشغيل وحماية حقوق الدائنين بإنصاف.",
//       icon: <FileSpreadsheet className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "إجراءات التصفية وحوكمتها",
//       desc: "إدارة عمليات التصفية العادية أو التصفية للمدينين الصغار، وحصر الموجودات وتسييلها لتوزيع الحصص على الدائنين وفقاً للأولويات والترتيب النظامي.",
//       icon: <Receipt className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "التمثيل القضائي في قضايا الإفلاس",
//       desc: "تمثيل الشركات (المدينين) أو الجهات التمويلية (الدائنين) أمام الدوائر التجارية بالمحاكم، والاعتراض على قرارات الأمناء وقيد المطالبات المالية بشكل نظامي.",
//       icon: <Scale className="w-6 h-6 text-amber-600" />
//     }
//   ];

//   return (
//     <div className="bg-white text-right font-sans" dir="rtl">
//       <ServicePageHeader 
//         title="إجراءات الإفلاس وإعادة الهيكلة المالية"
//         description="نقدم حلولاً قانونية شاملة لدعم نمو الشركات الناشئة وريادة الأعمال في السوق السعودي"
//       />
//       {/* Hero Header Section */}
//       <section className="relative bg-slate-900 text-white py-24 px-4 overflow-hidden">
//         <div className="absolute inset-0 opacity-15 bg-[url('https://images.unsplash.com/photo-1507679799987-c73779587ccf?auto=format&fit=crop&q=80')] bg-cover bg-center"></div>
//         <div className="max-w-6xl mx-auto relative z-10 text-center">
//           <span className="text-amber-500 font-semibold text-sm md:text-base tracking-wide block mb-3">حماية الاستدامة المؤسسية وإعادة الهيكلة الآمنة</span>
//           <h1 className="text-3xl md:text-5xl font-bold mb-6 text-slate-100 leading-tight">إجراءات الإفلاس وإعادة الهيكلة المالية</h1>
//           <p className="text-slate-300 max-w-3xl mx-auto text-base md:text-lg leading-relaxed">
//             التعثر المالي ليس نهاية المطاف. نوفر لمنشأتك المظلة القانونية والاستراتيجية اللازمة للاستفادة من مزايا نظام الإفلاس السعودي، وحمايتها من التصفية القسرية لضمان عودتها إلى السوق بشكل أقوى.
//           </p>
//         </div>
//       </section>

//       {/* Strategic and Structural Protection Framework */}
//       <section className="max-w-6xl mx-auto py-20 px-4">
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
//           <div>
//             <h2 className="text-2xl md:text-4xl font-bold text-slate-800 mb-6 leading-tight">
//               أدوات نظام الإفلاس: طوق النجاة للشركات المتعثرة
//             </h2>
//             <p className="text-gray-600 text-lg leading-relaxed mb-4">
//               عندما تواجه الشركات اضطرابات في التدفقات النقدية، فإن المبادرة بطلب الحماية بموجب نظام الإفلاس تحمي مجلس الإدارة من الملاحقات القضائية الفردية وتمنع الدائنين من الحجز الفوري على أصول ومستودعات الشركة.
//             </p>
//             <p className="text-gray-600 text-lg leading-relaxed">
//               يتولى فريقنا القانوني والمالي المشترك دراسة الملاءة المالية للمنشأة، وتحديد الخيار النظامي الأنسب (سواء كان تسوية وقائية أو إعادة تنظيم)، وصياغة خطط السداد الواقعية التي تقنع الدائنين والمحكمة التجارية، مما يمنح الإدارة الوقت الكافي لالتقاط الأنفاس وإعادة التوازن المالي للكيان.
//             </p>
//           </div>
          
//           {/* Why Apply For Bankruptcy Provisions Box */}
//           <div className="bg-slate-50 p-8 rounded-2xl border border-slate-100 space-y-6">
//             <h3 className="text-xl font-bold text-slate-800 mb-2 flex items-center gap-2">
//               <Landmark className="w-5 h-5 text-amber-600" /> المزايا الحمائية لنظام الإفلاس:
//             </h3>
            
//             <div className="flex gap-3 items-start">
//               <CheckCircle2 className="w-5 h-5 text-amber-600 shrink-0 mt-1" />
//               <p className="text-gray-600 text-sm leading-relaxed">**تعليق المطالبات:** وقف كافة دعاوى التنفيذ والأحكام القضائية الموجهة ضد الشركة فور قيد الطلب نظاماً.</p>
//             </div>

//             <div className="flex gap-3 items-start">
//               <CheckCircle2 className="w-5 h-5 text-amber-600 shrink-0 mt-1" />
//               <p className="text-gray-600 text-sm leading-relaxed">**استمرار الإدارة:** الاحتفاظ بسلطة تسيير الأعمال والعمليات اليومية تحت حماية المحكمة التجارية.</p>
//             </div>

//             <div className="flex gap-3 items-start">
//               <CheckCircle2 className="w-5 h-5 text-amber-600 shrink-0 mt-1" />
//               <p className="text-gray-600 text-sm leading-relaxed">**تحصين الذمة المالية:** حماية الشركاء والمديرين من المسؤولية الشخصية التضامنية عن ديون الشركة.</p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Grid Capability Matrix Breakdown */}
//       <section className="bg-slate-900 text-white py-20 px-4">
//         <div className="max-w-6xl mx-auto">
//           <div className="text-center mb-16">
//             <h2 className="text-2xl md:text-4xl font-bold mb-3">نطاق العمل في حلول التعثر والهيكلة</h2>
//             <p className="text-slate-400 max-w-xl mx-auto">خيارات نظامية متكاملة مصممة لإنقاذ الكيانات التجارية وحفظ القيمة الاستثمارية لأصولها</p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//             {bankruptcyServices.map((service, index) => (
//               <div key={index} className="bg-slate-800/60 p-8 rounded-xl border border-slate-700 hover:border-amber-500 transition-all duration-300">
//                 <div className="bg-slate-700/50 p-3 rounded-lg w-fit mb-5">
//                   {service.icon}
//                 </div>
//                 <h3 className="text-xl font-bold text-slate-100 mb-2">{service.title}</h3>
//                 <p className="text-slate-400 text-sm leading-relaxed">{service.desc}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Strict Regulatory Context / Liability Alert */}
//       <section className="max-w-4xl mx-auto py-16 px-4">
//         <div className="bg-amber-50 rounded-xl border border-amber-200 p-6 flex gap-4 items-start">
//           <ShieldAlert className="w-6 h-6 text-amber-600 shrink-0 mt-0.5" />
//           <div>
//             <h4 className="font-bold text-slate-800 mb-1">مسؤولية المديرين أثناء التعثر (تنبيه مصيري):</h4>
//             <p className="text-amber-950 text-sm leading-relaxed">
//               وفقاً لنظام الشركات الجديد واللوائح المنظمة للإفلاس، إذا بلغت خسائر الشركة ذات المسؤولية المحدودة **50% من رأس مالها**، يجب على المديرين توجيه الدعوة للشركاء للاجتماع لمعالجة الوضع خلال مدد محددة. إن إهمال معالجة التعثر أو التأخر في طلب إجراء الإفلاس المناسب عند بلوغ مرحلة الاضطراب المالي قد يعرض المديرين **للمساءلة الشخصية ومطالبتهم بسداد ديون الشركة من أموالهم الخاصة** باعتبارهم مقصرين في أداء واجبات الرعاية.
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* Active Lead Gen Conversion Block */}
//       <section className="max-w-4xl mx-auto pb-20 px-4 text-center">
//         <div className="inline-flex p-3 bg-slate-100 rounded-full text-slate-800 mb-4">
//           <TrendingDown className="w-6 h-6" />
//         </div>
//         <h3 className="text-xl font-bold text-slate-800 mb-2">هل تواجه منشأتك ضغوطاً مالية أو التزامات متراكمة؟</h3>
//         <p className="text-gray-500 text-sm max-w-xl mx-auto mb-6">
//           تواصل مع مستشارينا المعتمدين اليوم في سرّية تامة لدراسة الوضع المالي لشركتك، واستكشاف أفضل الخيارات الحمائية التي يتيحها النظام لحفظ كيانك التجاري.
//         </p>
//         <button className="bg-amber-600 text-white font-medium text-sm px-6 py-3 rounded-lg hover:bg-amber-700 transition-colors shadow-md inline-flex items-center gap-2">
//           طلب استشارة وفحص الموقف المالي للمنشأة
//           <ChevronLeft className="w-4 h-4" />
//         </button>
//       </section>

//     </div>
//   );
// }


import React from 'react';
import { 
  TrendingDown, ShieldAlert, Landmark, Scale, 
  ChevronLeft, CheckCircle2, ShieldCheck, FileSpreadsheet, 
  HelpCircle, Receipt 
} from 'lucide-react';
import { ServicePageHeader } from '../ServicePageHeader';

export default function BankruptcyProceedings() {
  
  // Core bankruptcy and financial restructuring offerings - Refactored to Navy Light
  const bankruptcyServices = [
    {
      title: "إجراء التسوية الوقائية",
      desc: "تمكين المدين المتعثر من التوصل إلى اتفاق مع دائنيه لإعادة جدولة الديون واستمرار إدارة النشاط دون تدخل أمين الإفلاس، مع الاستفادة من ميزة تعليق المطالبات.",
      icon: <ShieldCheck className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "إعادة التنظيم المالي",
      desc: "إعداد ومتابعة مقترحات الهيكلة المالية والإدارية للشركات تحت إشراف أمين إفلاس مرخص، لضمان استمرارية التشغيل وحماية حقوق الدائنين بإنصاف.",
      icon: <FileSpreadsheet className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "إجراءات التصفية وحوكمتها",
      desc: "إدارة عمليات التصفية العادية أو التصفية للمدينين الصغار، وحصر الموجودات وتسييلها لتوزيع الحصص على الدائنين وفقاً للأولويات والترتيب النظامي.",
      icon: <Receipt className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "التمثيل القضائي في قضايا الإفلاس",
      desc: "تمثيل الشركات (المدينين) أو الجهات التمويلية (الدائنين) أمام الدوائر التجارية بالمحاكم، والاعتراض على قرارات الأمناء وقيد المطالبات المالية بشكل نظامي.",
      icon: <Scale className="w-6 h-6 text-indigo-950" />
    }
  ];

  return (
    <div className="bg-white text-right font-sans min-h-screen" dir="rtl">
      <ServicePageHeader 
        title="إجراءات الإفلاس وإعادة الهيكلة المالية"
        description="نقدم حلولاً قانونية شاملة لدعم المنشآت وحماية الاستدامة المؤسسية في السوق السعودي"
      />
      
      {/* Hero Header Section - Converted to Premium Light Mode */}
      <section className="relative bg-slate-50 border-b border-slate-100 py-24 px-4 overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1507679799987-c73779587ccf?auto=format&fit=crop&q=80')] bg-cover bg-center"></div>
        {/* White/Slate overlay for premium executive appearance */}
        <div className="absolute inset-0 bg-white/90 backdrop-blur-[1px]"></div>
        
        <div className="max-w-6xl mx-auto relative z-10 text-center">
          <span className="text-blue-700 font-bold text-xs md:text-sm tracking-wide block mb-3 uppercase">حماية الاستدامة المؤسسية وإعادة الهيكلة الآمنة</span>
          <h1 className="text-3xl md:text-5xl font-extrabold mb-6 text-indigo-950 leading-tight">إجراءات الإفلاس وإعادة الهيكلة المالية</h1>
          <p className="text-slate-600 max-w-3xl mx-auto text-base md:text-lg leading-relaxed font-light">
            التعثر المالي ليس نهاية المطاف. نوفر لمنشأتك المظلة القانونية والاستراتيجية اللازمة للاستفادة من مزايا نظام الإفلاس السعودي، وحمايتها من التصفية القسرية لضمان عودتها إلى السوق بشكل أقوى.
          </p>
        </div>
      </section>

      {/* Strategic and Structural Protection Framework */}
      <section className="max-w-6xl mx-auto py-20 px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-2xl md:text-4xl font-extrabold text-indigo-950 mb-6 leading-tight">
              أدوات نظام الإفلاس: طوق النجاة للشركات المتعثرة
            </h2>
            <p className="text-slate-600 text-base md:text-lg leading-relaxed mb-4 font-light">
              عندما تواجه الشركات اضطرابات في التدفقات النقدية، فإن المبادرة بطلب الحماية بموجب نظام الإفلاس تحمي مجلس الإدارة من الملاحقات القضائية الفردية وتمنع الدائنين من الحجز الفوري على أصول ومستودعات الشركة.
            </p>
            <p className="text-slate-600 text-base md:text-lg leading-relaxed font-light">
              يتولى فريقنا القانوني والمالي المشترك دراسة الملاءة المالية للمنشأة، وتحديد الخيار النظامي الأنسب (سواء كان تسوية وقائية أو إعادة تنظيم)، وصياغة خطط السداد الواقعية التي تقنع الدائنين والمحكمة التجارية، مما يمنح الإدارة الوقت الكافي لالتقاط الأنفاس وإعادة التوازن المالي للكيان.
            </p>
          </div>
          
          {/* Why Apply For Bankruptcy Provisions Box - Refactored to Executive Light Mode */}
          <div className="bg-slate-50 p-8 rounded-2xl border border-slate-200/60 space-y-6 shadow-sm">
            <h3 className="text-xl font-bold text-indigo-950 mb-2 flex items-center gap-2">
              <Landmark className="w-5 h-5 text-blue-700" /> المزايا الحمائية لنظام الإفلاس:
            </h3>
            
            <div className="flex gap-3 items-start">
              <CheckCircle2 className="w-5 h-5 text-indigo-950 shrink-0 mt-1" />
              <p className="text-slate-600 text-sm leading-relaxed font-light"><strong className="text-indigo-950">تعليق المطالبات:</strong> وقف كافة دعاوى التنفيذ والأحكام القضائية الموجهة ضد الشركة فور قيد الطلب نظاماً.</p>
            </div>

            <div className="flex gap-3 items-start">
              <CheckCircle2 className="w-5 h-5 text-indigo-950 shrink-0 mt-1" />
              <p className="text-slate-600 text-sm leading-relaxed font-light"><strong className="text-indigo-950">استمرار الإدارة:</strong> الاحتفاظ بسلطة تسيير الأعمال والعمليات اليومية تحت حماية المحكمة التجارية.</p>
            </div>

            <div className="flex gap-3 items-start">
              <CheckCircle2 className="w-5 h-5 text-indigo-950 shrink-0 mt-1" />
              <p className="text-slate-600 text-sm leading-relaxed font-light"><strong className="text-indigo-950">تحصين الذمة المالية:</strong> حماية الشركاء والمديرين من المسؤولية الشخصية التضامنية عن ديون الشركة.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Grid Capability Matrix Breakdown - Converted to Premium Light Grid */}
      <section className="bg-slate-50/50 border-y border-slate-100 py-20 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-2xl md:text-4xl font-extrabold text-indigo-950 mb-3">نطاق العمل في حلول التعثر والهيكلة</h2>
            <p className="text-slate-500 text-sm md:text-base font-light">خيارات نظامية متكاملة مصممة لإنقاذ الكيانات التجارية وحفظ القيمة الاستثمارية لأصولها</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {bankruptcyServices.map((service, index) => (
              <div key={index} className="bg-white p-8 rounded-xl border-t-4 border-t-indigo-950 border-x border-b border-slate-100 shadow-sm hover:shadow-md transition-all duration-300">
                <div className="bg-slate-50 p-3 rounded-lg w-fit mb-5">
                  {service.icon}
                </div>
                <h3 className="text-xl font-bold text-indigo-950 mb-2">{service.title}</h3>
                <p className="text-slate-600 text-sm leading-relaxed font-light">{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Strict Regulatory Context / Liability Alert - Adjusted to Slate Balance Tone */}
      <section className="max-w-4xl mx-auto py-20 px-4">
        <div className="bg-slate-50 rounded-xl border border-slate-200/60 p-6 flex gap-4 items-start shadow-sm">
          <ShieldAlert className="w-6 h-6 text-indigo-950 shrink-0 mt-0.5" />
          <div>
            <h4 className="font-bold text-indigo-950 mb-1">مسؤولية المديرين أثناء التعثر (تنبيه مصيري):</h4>
            <p className="text-slate-600 text-sm leading-relaxed font-light">
              وفقاً لنظام الشركات الجديد واللوائح المنظمة للإفلاس، إذا بلغت خسائر الشركة ذات المسؤولية المحدودة <strong className="text-indigo-950">50% من رأس مالها</strong>، يجب على المديرين توجيه الدعوة للشركاء للاجتماع لمعالجة الوضع خلال مدد محددة. إن إهمال معالجة التعثر أو التأخر في طلب إجراء الإفلاس المناسب عند بلوغ مرحلة الاضطراب المالي قد يعرض المديرين <strong className="text-indigo-950">للمساءلة الشخصية ومطالبتهم بسداد ديون الشركة من أموالهم الخاصة</strong> باعتبارهم مقصرين في أداء واجبات الرعاية.
            </p>
          </div>
        </div>
      </section>

      {/* Active Lead Gen Conversion Block - Refactored Styles */}
      <section className="max-w-4xl mx-auto pb-20 px-4 text-center">
        <div className="inline-flex p-3 bg-slate-50 rounded-full text-indigo-950 border border-slate-100 shadow-sm mb-4">
          <TrendingDown className="w-6 h-6 text-blue-700" />
        </div>
        <h3 className="text-xl font-bold text-indigo-950 mb-2">هل تواجه منشأتك ضغوطاً مالية أو التزامات متراكمة؟</h3>
        <p className="text-slate-500 text-sm max-w-xl mx-auto mb-6 font-light">
          تواصل مع مستشارينا المعتمدين اليوم في سرّية تامة لدراسة الوضع المالي لشركتك، واستكشاف أفضل الخيارات الحمائية التي يتيحها النظام لحفظ كيانك التجاري.
        </p>
        <button className="bg-indigo-950 text-white font-bold text-sm px-6 py-3 rounded-lg hover:bg-slate-900 transition-all duration-200 shadow-sm inline-flex items-center gap-2">
          طلب استشارة وفحص الموقف المالي للمنشأة
          <ChevronLeft className="w-4 h-4" />
        </button>
      </section>

    </div>
  );
}